import { createSlice } from "@reduxjs/toolkit";
import { AddVendor, UpdateVendor, GetVendorList, GetVendorNameList } from "services/vendor/vendor.service";
import { toast } from 'react-toastify';

export const vendorAddSlice = createSlice({
  name: "vendorAdd",
  initialState: {
    vendorAdd: {},
    vendorAddLoading: false,
    vendorAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddVendor.pending, (state) => {
      // toast.loading('We are adding the vendor 🤯')
      state.vendorAddLoading = true
    });

    builder.addCase(AddVendor.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New vendor added successfully 👌');

      state.vendorAdd = action.payload
      state.vendorAddLoading = false
      state.vendorAddError = null
    });

    builder.addCase(AddVendor.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the vendor 😣")

      state.vendorAddLoading = false
      state.vendorAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const vendorUpdateSlice = createSlice({
  name: "vendorUpdate",
  initialState: {
    vendorUpdate: {},
    vendorUpdateLoading: false,
    vendorUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateVendor.pending, (state) => {
      // toast.loading('We are updating the vendor 🤯')
      state.vendorUpdateLoading = true
    });

    builder.addCase(UpdateVendor.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.vendorUpdate = action.payload
      state.vendorUpdateLoading = false
      state.vendorUpdateError = null
    });

    builder.addCase(UpdateVendor.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the vendor 😣")

      state.vendorUpdateLoading = false
      state.vendorUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const vendorListSlice = createSlice({
  name: "vendorList",
  initialState: {
    vendorList: [],
    vendorListLoading: false,
    vendorListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetVendorList.pending, (state) => {
      state.vendorListLoading = true
    });

    builder.addCase(GetVendorList.fulfilled, (state, action) => {
      toast.dismiss();

      state.vendorList = action.payload
      state.vendorListLoading = false
      state.vendorListError = null
    });

    builder.addCase(GetVendorList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the vendor 😣")

      state.vendorListLoading = false
      state.vendorListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const vendorNameListSlice = createSlice({
  name: "vendorNameList",
  initialState: {
    vendorNameList: [],
    vendorNameListLoading: false,
    vendorNameListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetVendorNameList.pending, (state) => {
      state.vendorNameListLoading = true
    });

    builder.addCase(GetVendorNameList.fulfilled, (state, action) => {
      toast.dismiss();

      state.vendorNameList = action.payload
      state.vendorNameListLoading = false
      state.vendorNameListError = null
    });

    builder.addCase(GetVendorNameList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the vendor 😣")

      state.vendorNameListLoading = false
      state.vendorNameListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});